import API from '@/api';
export default {
	getUsers: () => {
		return API.get(`/users`);
	},
};
